import { Box, IconButton, List, OutlinedInput, styled } from '@mui/material';
import CTypography from 'components/CTypography';

export const PreviewCnt = styled(Box)({
  overflowY: 'auto',
  height: '100%',
  width: 450,
  padding: '15px 15px 2px',
  background: '#F6F8FA',
  borderLeft: '1px solid #E0E0E0',
  '& .title': {
    fontSize: '16px',
    fontWeight: 800,
    marginBottom: '16px',
    '& svg': {
      cursor: 'pointer',
    },
  },
});
export const StyledCard = styled(Box)({
  padding: 16,
  background: '#FFFFFF',
  borderRadius: 8,
  border: '1px solid #FFFFFF',
  display: 'flex',
  flex: 1,
  justifyContent: 'space-between',
  gap: 8,
  boxShadow: '0px 2px 4px 0px #0000001A',
  '& .cardValue': {
    fontSize: '16px',
    fontWeight: 700,
    color: '#000000',
    marginBottom: 2,
  },
  '& .cardTitle': {
    fontSize: '13px',
    fontWeight: 600,
    color: '#424242',
  },
  '& .cardText': {
    fontSize: '14px',
    fontWeight: 600,
    color: '#000000',
    marginTop: 2,
  },
  '& .icon': {
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#F6F8FA',
    borderRadius: '50%',
  },
});

export const PreviewAssigneeListCnt = styled(Box)({
  padding: '12px',
  borderRadius: '8px',
  background: '#fff',
  boxShadow: '0px 2px 4px 0px #0000001A',
  '& .previewAssigneeItem+ .previewAssigneeItem': {
    borderTop: '1px solid #EEEEEE',
    marginTop: '8px',
    paddingTop: '8px',
  },
  '& .icon': {
    width: 60,
    height: 60,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    margin: '15px auto',
    background: '#E0F2F1',
    '& path': { fill: '#009688' },
    '& svg': {
      fontSize: '24px',
    },
  },
});

export const LocationIconCnt = styled(Box)({
  border: '1px solid rgb(224, 224, 224)',
  borderRadius: 100,
  gap: 5,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: 5,
  fontSize: 13,
  fontWeight: 600,
  color: '#212121',
});
